function normalizeString(value) {
  return typeof value === 'string' ? value : '';
}

export function composeHtmlEmailScaffold({ header = '', body = '', footer = '' } = {}) {
  return `${normalizeString(header)}${normalizeString(body)}${normalizeString(footer)}`;
}

export function getEmailTemplateContent(template = {}) {
  const header = normalizeString(template.header);
  const body = normalizeString(template.body);
  const footer = normalizeString(template.footer);

  if (!header && !footer) {
    return body;
  }

  return composeHtmlEmailScaffold({
    header,
    body,
    footer,
  });
}



// WEBPACK FOOTER //
// ./src/utils/emailScaffold.js